export default "__VITE_ASSET__34984004__"